import styled from "styled-components";

export const Textarea = styled.textarea`
    width: 100%;
    height: 150px;
    background: #f5f8fa;
    border: 1px solid #d3e2e5;
    border-radius: 5px;
    color: #5c8599;
    font-size:16px;
    :valid{
        border: 1px solid #A1E9C5;
    }
`